import { render } from "./AuthErrorPage.vue?vue&type=template&id=379f3a00&scoped=true"
import script from "./AuthErrorPage.vue?vue&type=script&lang=js"
export * from "./AuthErrorPage.vue?vue&type=script&lang=js"

import "./AuthErrorPage.vue?vue&type=style&index=0&id=379f3a00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379f3a00"]])

export default __exports__